import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import banner_img from "../../assets/banner_img.png";
import img1 from "../../assets/img1.png";
import img2 from "../../assets/img2.png";
import img3 from "../../assets/img3.png";
import img4 from "../../assets/img4.png";
import globe from "../../assets/globe.png";
import vector from "../../assets/Line 1.png";
import users from "../../assets/users.png";
import Footer from "../../components/Footer/Footer";
import bgImage from "../../assets/bg-banner.png";
import check from "../../assets/check.png";
import LoginPopup from "../../components/Auth/LoginPopup";
import WarningPopup from "../../components/Auth/WarningPopup";
import segmentMenu from "../../assets/segmentMenu.svg";
import { useUser } from "providers/UserProvider";
import { useEffect } from "react";
import { setSessionData } from "services/session.service";

const Home = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [segments, setSegments] = useState([
    "Name of Segment 1",
    "Name of Segment 2",
    "Name of Segment 3",
    "Name of Segment 4",
    "Name of Segment 5",
  ]);

  const [newSegmentTitle, setNewSegmentTitle] = useState("");
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);

  const handleAddSegment = () => {
    if (newSegmentTitle.trim()) {
      setSegments([...segments, newSegmentTitle]);
      setNewSegmentTitle("");
    }
  };

  const handleNextClick = () => {
    setShowWarningPopup(true);
  };

  const handleWarningClose = () => {
    setShowWarningPopup(false);
    setShowLoginPopup(true);
  };

  useEffect(() => {
    // console.log("user from home page before -> ", user);
    if (user.email) {
      // console.log("user from home page after -> ", user);
      setSessionData("email", user.email);
      navigate("/home");
    }
  }, [user]);

  return (
    <div className="min-[1500px]:flex min-[1500px]:flex-col min-[1500px]:justify-center min-[1500px]:items-center">
      <Header onLoginClick={() => setShowLoginPopup(true)} />
      {showWarningPopup && <WarningPopup onClose={handleWarningClose} />}

      {showLoginPopup && (
        <LoginPopup
          onClose={() => setShowLoginPopup(false)}
          onLoginSuccess={() => {}}
        />
      )}

      {/* section 1 - banner */}
      <div
        className="w-full"
        style={{
          backgroundImage: `url(${bgImage})`,
          // maxWidth: "2000px",
          backgroundSize: "cover",
        }}
      >
        <div
          className="flex justify-between font-inter pt-8 max-w-[1200px] mx-auto max-lg:flex-col max-lg:gap-8 max-xl:px-5"
          // style={{
          //   backgroundImage: `url(${bgImage})`,
          //   // maxWidth: "2000px",
          //   backgroundSize: "cover",
          // }}
        >
          {/* banner text */}
          <div className="w-5/12 pt-[43px] mr-3 max-lg:w-full">
            <h6 className="text-sm py-0.5 text-[#17773B] px-3.5 rounded-full border border-[#17773B] w-fit mb-[18px]">
              ABOUT SENTIOCAP
            </h6>
            <h1 className="text-[52px] max-lg:text-[42px] max-lg:leading-[50px] font-medium pb-[15px] px-[1px] leading-[62px] tracking-wide break-words">
              A Revolutionary and Reliable Solution for Global Finance
            </h1>
            <h5 className="pb-[33px] text-[20px] max-lg:text-[18px] max-lg:mb-[15px] leading-6 mt-[6px] mb-[29px]">
              At vero eos et accusamus et iusto odio dignissimos ducimus qui
              blanditiis praesentium.
            </h5>

            {/* get started and live demo buttons */}
            <div className="flex gap-3 pb-4 max-[400px]:flex-col">
              <button className="bg-[#55C880] px-5 py-[10px] rounded-[10px] w-fit text-white">
                Find Out More
              </button>
              <button className="border border-[#55C880] font-medium px-5 py-[10px] rounded-[10px] w-fit text-[#55C880]">
                View Live Demo
              </button>
            </div>

            <div className="flex pt-4 sm:items-center max-sm:w-fit max-[400px]:flex-col max-sm:gap-2">
              {/* profile images of review section */}
              <div className="flex max-w-[170px]">
                <img
                  src={img1}
                  alt=""
                  className="relative z-1 w-[45px] h-[45px] rounded-full border-2 border-white"
                />
                <img
                  src={img2}
                  alt=""
                  className="relative -left-2 z-2 w-[45px] h-[45px] rounded-full border-2 border-white"
                />
                <img
                  src={img3}
                  alt=""
                  className="relative -left-4 z-3 w-[45px] h-[45px] rounded-full border-2 border-white"
                />
                <img
                  src={img4}
                  alt=""
                  className="relative -left-6 z-4 w-[45px] h-[45px] rounded-full border-2 border-white"
                />
              </div>
              <div className="space-y-2">
                {/* stars of review */}
                <div className="flex gap-[10px]">
                  {/* star svg */}
                  <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.36875 14.75L4.5875 9.48124L0.5 5.93748L5.9 5.46873L8 0.499985L10.1 5.46873L15.5 5.93748L11.4125 9.48124L12.6312 14.75L8 11.9562L3.36875 14.75Z"
                      fill="#1C1B1F"
                    />
                  </svg>
                  <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.36875 14.75L4.5875 9.48124L0.5 5.93748L5.9 5.46873L8 0.499985L10.1 5.46873L15.5 5.93748L11.4125 9.48124L12.6312 14.75L8 11.9562L3.36875 14.75Z"
                      fill="#1C1B1F"
                    />
                  </svg>
                  <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.36875 14.75L4.5875 9.48124L0.5 5.93748L5.9 5.46873L8 0.499985L10.1 5.46873L15.5 5.93748L11.4125 9.48124L12.6312 14.75L8 11.9562L3.36875 14.75Z"
                      fill="#1C1B1F"
                    />
                  </svg>
                  <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.36875 14.75L4.5875 9.48124L0.5 5.93748L5.9 5.46873L8 0.499985L10.1 5.46873L15.5 5.93748L11.4125 9.48124L12.6312 14.75L8 11.9562L3.36875 14.75Z"
                      fill="#1C1B1F"
                    />
                  </svg>
                  <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.36875 14.75L4.5875 9.48124L0.5 5.93748L5.9 5.46873L8 0.499985L10.1 5.46873L15.5 5.93748L11.4125 9.48124L12.6312 14.75L8 11.9562L3.36875 14.75Z"
                      fill="#1C1B1F"
                    />
                  </svg>
                </div>
                <p className="text-[12px] font-[400] text-[#000000] opacity-60 ">
                  Trusted by 2K+ Customers
                </p>
              </div>
            </div>
          </div>

          {/* banner image */}
          <div className="relative mt-[18px] pr-[116px]">
            <img
              src={banner_img}
              alt=""
              className="md:h-[598px] md:min-h-[598px] md:min-w-[487px] max-md:min-w-[300px] max-md:min-h-[404px] max-sm:min-w-[220px] max-sm:min-h-[300px]"
            />
            {/* card 1 */}
            <div className="absolute rounded-r-[1400px] rounded-l-[9999px] bg-[#EBE8D8] lg:top-[16.5rem] lg:-left-5 max-lg:w-[180px] max-lg:h-[110px] max-lg:bottom-[120px] max-lg:-right-4 max-md:w-[120px] max-md:h-[70px] max-md:bottom-[80px]">
              <p className="text-[42px] leading-none font-medium text-[#1C3F3A] max-lg:text-[25px] md:ml-12 md:mt-8 max-md:ml-8 max-md:mt-3 max-md:text-[18px]">
                56+
              </p>
              <div className="w-full flex gap-[3rem] mt-1 pb-4 pr-5 text-[#1C3F3A] max-lg:gap-7">
                <p className="text-[14px] font-semibold max-lg:text-[12px] md:ml-[46px] max-md:text-[10px] max-md:ml-[32px]">
                  Currencies
                </p>
                <img
                  src={globe}
                  alt=""
                  className="w-[49px] pt-2 max-lg:w-[28px] max-md:hidden"
                />
              </div>
            </div>
            {/* card 2 */}
            <div className="absolute rounded-[10px] text-white bg-[#1C3F3A] w-[235px] h-[148px] right-0 lg:top-36 max-lg:w-[180px] max-lg:h-[110px] max-lg:bottom-[240px] max-md:flex max-md:flex-col max-md:items-center max-md:justify-center max-md:w-[120px] max-md:h-[70px] max-md:bottom-[160px]">
              <p className="text-[23px] max-lg:text-[18px] md:pl-5 md:pt-[0.625rem]">
                $196,000
              </p>
              <p className="text-sm lg:pb-[13px] max-lg:text-[10px] md:pl-5">
                Grow Saving Faster
              </p>
              <img src={vector} alt="" className="max-md:hidden" />
            </div>
            {/* card 3 */}
            <div className="absolute rounded-tr-[80px] rounded-tl-[10px] bg-[#E0EAE8] lg:bottom-0 lg:right-[61px] max-lg:w-[180px] max-lg:h-[110px] max-lg:bottom-0 max-lg:-right-4 max-md:w-[120px] max-md:h-[70px]">
              <p className="text-[2.625rem] leading-none tracking-wide font-medium ml-7 mb-1 mt-6 text-[#1C3F3A] max-lg:text-[25px] max-md:text-[18px]">
                215K
              </p>
              <div className="w-full flex justify-between gap-10 pr-6 mb-4">
                <p className="text-sm pl-7 font-medium text-[#1C3F3A] max-lg:text-[12px] max-md:text-[10px]">
                  Active Users
                </p>
                <img
                  src={users}
                  alt=""
                  className="w-14 pt-2 max-lg:w-[28px] max-md:hidden"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* asset allocation */}
      <div className="mt-[73px] mb-[202px] font-inter max-w-[1200px] mx-auto w-full max-xl:px-5">
        <div className="flex justify-between">
          <h1 className="text-[32px] tracking-wide mb-[30px] font-medium">
            Asset Allocation
          </h1>

          {/* progress circle */}
          <div className="rounded-full relative p-2 w-14 h-14 max-md:hidden">
            <div className="w-full h-full rounded-full bg-gray-100"></div>

            <div
              className="absolute top-0 left-0 w-full h-full"
              style={{
                background:
                  "conic-gradient(rgba(28, 63, 58, 1) 13%,rgba(235, 230, 230, 1) 13%)",
                borderRadius: "100%",
              }}
            ></div>

            <div
              className="absolute top-0 left-0 w-full h-full rounded-full bg-white flex items-center justify-center m-[4px]"
              style={{ width: "calc(100% - 8px)", height: "calc(100% - 8px)" }}
            >
              <span className="text-[16px] font-medium">1/7</span>
            </div>
          </div>
        </div>

        <div className="bg-[#F4F5F6] pt-8 pb-6 px-10 rounded-lg">
          <div className="bg-[#1C3F3A] text-white px-[11px] w-fit py-[0.325rem] rounded-md text-[12px]">
            Level 1
          </div>
          <p className="mt-3 mb-6 text-[1.25rem] font-medium">
            Please indicate the primary operating segments within your company
            which you currently track
          </p>
          <div className="">
            <div className="flex flex-wrap gap-2.5 gap-y-5 mb-3">
              {/* existing segment */}
              {segments.map((segment, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between px-[0.75rem] py-[0.325rem] w-[210px] bg-white rounded-lg shadow-sm border border-[#D9D9D9]"
                >
                  <span className="font-[500]">{segment}</span>
                  <button
                    className="text-gray-400"
                    aria-label={`Edit ${segment}`}
                  >
                    <img src={segmentMenu} alt="" className="" />
                  </button>
                </div>
              ))}

              {/* add new segment */}
              <div className="relative w-[210px]">
                <input
                  type="text"
                  value={newSegmentTitle}
                  onChange={(e) => setNewSegmentTitle(e.target.value)}
                  placeholder="Enter Segment Title"
                  className="px-4 py-[0.325rem] w-full border border-[#D9D9D9] rounded-[6px] focus:outline-none"
                  disabled
                />
                <img
                  src={check}
                  alt=""
                  className="absolute right-3 top-3 max-sm:hidden"
                />
              </div>
              {/* add new segment button */}
              <button
                onClick={handleAddSegment}
                className="relative py-[0.375rem] w-[210px] font-medium rounded-[6px] text-[#1C3F3A] hover:bg-[#f0f0f0] transition-colors"
                disabled
              >
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 210 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="absolute inset-0"
                  preserveAspectRatio="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="99%"
                    height="97%"
                    rx="5.5"
                    fill="white"
                    stroke="#1C3F3A"
                    strokeWidth="1"
                    strokeDasharray="4 4"
                  />
                </svg>
                <span className="relative z-10">Add New Segment</span>
              </button>
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-[26px]">
          <button
            onClick={handleNextClick}
            className="bg-[#55C880] flex gap-3 justify-center items-center text-white pl-5 pr-6 py-[0.825rem] rounded-[10px]"
          >
            Next
            <svg
              width="17"
              height="8"
              viewBox="0 0 17 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.1923 7.80776L12.4788 7.10001L15.0788 4.50001H0V3.50001H15.0788L12.4845 0.900011L13.198 0.192261L17 4.00001L13.1923 7.80776Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
